/** Format a numeric value without trailing zeros (e.g. 2.5, 22, 21). */
function formatUnitValue(value: number, maxDecimals: number): string {
  if (Number.isInteger(value)) return String(value);
  return value.toFixed(maxDecimals).replace(/\.?0+$/, '');
}

/**
 * Format a length in millimetres for display.
 * - &lt; 100 mm → mm (e.g. 21 → "21mm")
 * - 100–999 mm → cm (e.g. 220 → "22cm")
 * - ≥ 1000 mm → m (e.g. 2500 → "2.5m")
 */
export function formatMeasurementMm(mm: number): string {
  if (!Number.isFinite(mm)) return '—';

  const sign = mm < 0 ? '-' : '';
  const abs = Math.abs(mm);

  if (abs >= 1000) {
    return `${sign}${formatUnitValue(abs / 1000, 2)}m`;
  }
  if (abs >= 100) {
    return `${sign}${formatUnitValue(abs / 10, 1)}cm`;
  }

  if (Number.isInteger(mm)) {
    return `${sign}${Math.round(abs)}mm`;
  }
  return `${sign}${formatUnitValue(abs, 2)}mm`;
}

/** Join several mm values (e.g. thickness × width × length). */
export function formatMeasurementsMm(
  values: readonly (number | null | undefined)[],
  separator = ' × ',
): string {
  const parts = values.filter((v): v is number => v != null && Number.isFinite(v)).map(formatMeasurementMm);
  return parts.length > 0 ? parts.join(separator) : '—';
}
